"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidEducatorId = void 0;
const AnalyticsError_1 = __importDefault(require("../AnalyticsError"));
class InvalidEducatorId extends AnalyticsError_1.default {
    constructor(detail) {
        super('invalid-educator-id', 'Invalid Educator ID', detail, 400);
    }
}
exports.InvalidEducatorId = InvalidEducatorId;
exports.default = InvalidEducatorId;
